import React from "react";
import { Wrapper, Container, Row, Col, Disp, Dot } from "./style";
import { Icon } from "semantic-ui-react";
import { useContext } from "react";
import { ThemeContext } from "../../ThemedContext/Provider";
import Title from "../Commons/Title";

const image1 = "../../../assets/images/tp1.png";
const image2 = "../../../assets/images/tp2.png";
const image3 = "../../../assets/images/tp3.png";
const image4 = "../../../assets/images/tp4.png";
const image5 = "../../../assets/images/tp5.png";

const contents = [
  { image: image1, title: "Let me love you", name: "Auguste Rodin" },
  { image: image2, title: "Until i met you", name: "Henry Moore" },
  { image: image3, title: "Let me love you", name: "Marc Chagall" },
  { image: image4, title: "Dark Alley Acotic", name: "Brain Hills" },
  { image: image5, title: "Walking promises", name: "Ava Cornish" },
  { image: image5, title: "Walking promises", name: "Ava Cornish" },
];

const TopSongs = ({ subTitle }) => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper>
      <Title title={subTitle ? subTitle : "NEW SONGS"} />
      <Container>
        {contents.map((content, idx) => (
          <Row key={idx} themed={theme}>
            <Col style={{height: '3em'}}>

              <img src={content.image} alt='songs' style={{height: '100%'}}/>

            </Col>
            <Col>
              <Disp>
                <h5>{content.title}</h5>
                <p>{content.name}</p>
              </Disp>
            </Col>
            <Col>
              <p>8M+</p>
            </Col>
            <Col>
              <p>4:22</p>
            </Col>
            <Col>
              <Dot>
                {[1, 2, 3].map((d) => (
                  <Icon style={{ fontSize: '0.3em', height: '1.5em' }} name='dot circle' size='tiny' key={d} />
                ))}
              </Dot>
            </Col>
          </Row>
        ))}
      </Container>
    </Wrapper>
  );
};

export default TopSongs;
